// @flow
export type FeaturePermission =
  | 'FOLLO_MODULE'
  | 'SALES_INVENTORY_MODULE'
  | 'QUALITATIVE_MODULE'
  | 'DEMOGRAPHY_MODULE'
  | 'REACH_BY_ANTENNA_MODULE'
  | 'CENTRAL_MARKET_MODULE'
  ;

export const FeaturePermissions = {
  FOLLO_MODULE: 'FOLLO_MODULE',
  SALES_INVENTORY_MODULE: 'SALES_INVENTORY_MODULE',
  QUALITATIVE_MODULE: 'QUALITATIVE_MODULE',
  DEMOGRAPHY_MODULE: 'DEMOGRAPHY_MODULE',
  REACH_BY_ANTENNA_MODULE: 'REACH_BY_ANTENNA_MODULE',
  CENTRAL_MARKET_MODULE: 'REACH_BY_ANTENNA_MODULE',
};



// WEBPACK FOOTER //
// ./src/common/domain/FeaturePermission.js